import styled from 'styled-components';
import ColorConstants from '../../../shared/constants/ColorConstants';

export const Tag = styled.button`
    border: none;
    border-radius: 30px;
    margin: 3px;
    padding: 10px 8px;
    background-color: ${ColorConstants['catskill-white']};
    color: #17394D;
    font-family: Helvetica, sans-serif;
    font-size: 12px;
    line-height: 12px;
`;
